import instance from './api';

export const login = (data) => instance.post('admin/admin-login', data);
